import ZoomImg from './zoomImg'
import Situation from './situation'

export default{
  ZoomImg,
  Situation
}